import { Site } from '@ps/web-core-enums';

import type { LocationLaunchProps, LocationStateProps } from '@swf/casino';
import { StatusCode } from '@swf/core/enums/statusCode';
import type { ErrorBody, RequestError } from '@swf/core/errors/RequestError';
import { select } from '@swf/core/store';
import type { EffectParams } from '@swf/core/store';

const gameSessionCheck = async (
  payload: LocationLaunchProps,
  { dispatch, request, rootState }: EffectParams
): Promise<void> => {
  if (Site.ES === select.cms.getSiteId(rootState)) {
    try {
      await request({ service: 'casino.player.esgamesession' });
    } catch (error) {
      const { headers, body } = error as RequestError<ErrorBody & { data?: string }>;

      const statusCode = headers?.statusCode || StatusCode.TIMEOUT_ERROR;
      const locationState: Partial<LocationStateProps> = {
        statusCode,
        message: body.message,
        ...payload
      };

      switch (statusCode) {
        case StatusCode.ERR_ES_RG_REJECT_UNTIL:
          dispatch.modal.enqueue({
            path: '/notifications/es-playing-restricted',
            locationState: { restrictedUntil: new Date(parseInt(body.data || '') * 1000) }
          });
          throw error;
        case StatusCode.ERR_ES_RG_LIMIT_NOT_SET_SHOW_PROMPT:
          dispatch.modal.enqueue({
            path: '/casino/es-gaming-limit',
            locationState
          });
          throw error;
        case StatusCode.TIMEOUT_ERROR:
          throw error;
      }
      dispatch.modal.enqueue({
        path: '/casino/gaming-session-error',
        locationState
      });

      throw error;
    }
  }
};

export default gameSessionCheck;
